export default __webpack_public_path__ + "static/media/eq_tendency.71c4db9d.svg";